import { render, staticRenderFns } from "./FieldTypeDataTableWindow.vue?vue&type=template&id=2752d498&scoped=true&"
import script from "./FieldTypeDataTableWindow.vue?vue&type=script&lang=js&"
export * from "./FieldTypeDataTableWindow.vue?vue&type=script&lang=js&"
import style0 from "./FieldTypeDataTableWindow.vue?vue&type=style&index=0&id=2752d498&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2752d498",
  null
  
)

export default component.exports